import { defineComponent, ref } from 'vue';
import BSButton from '@/components/shared/bootstrap/Button.vue';
import AppUploadDocumentAttachmentsWithNotes from '@/components/shared/AppUploadDocumentAttachmentsWithNotes.vue';
import VehicleInspectionSheet from '@/components/document/documentManagement/VehicleInspectionSheet.vue';
import VehicleInspectionReport from '@/components/document/documentManagement/VehicleInspectionReport.vue';
import BSModal from '@/components/shared/bootstrap/Modal.vue';
export default defineComponent({
    emits: ['disableSubmit', 'enableSubmit'],
    components: {
        BSButton,
        AppUploadDocumentAttachmentsWithNotes,
        VehicleInspectionSheet,
        VehicleInspectionReport,
        BSModal
    },
    props: {
        documentId: {
            required: true,
            type: String
        },
        submissionProgress: {
            required: true,
            type: Number
        },
        isSubmitting: {
            required: true,
            type: Boolean
        }
    },
    setup() {
        const vehicleInspectionSheet = ref();
        const vehicleInspectionReport = ref();
        const vehicleInspectionPhotos = ref();
        const vehicleInspectionSupportingDocuments = ref();
        const tabChangeConfirmationModal = ref();
        return { vehicleInspectionSheet, vehicleInspectionReport, vehicleInspectionPhotos, vehicleInspectionSupportingDocuments, tabChangeConfirmationModal };
    },
    data() {
        return {
            activeTab: 'supportingDocuments',
            yesButton: {
                text: 'Yes',
                show: true
            },
            noButton: {
                text: 'No',
                show: true
            },
            possibleTab: ''
        };
    },
    methods: {
        tabChange(tabId) {
            if (this.activeTab === 'inspectionSheet' || this.activeTab === 'inspectionReport') {
                this.possibleTab = tabId;
                if (this.tabChangeConfirmationModal) {
                    this.tabChangeConfirmationModal.show();
                }
            }
            else {
                this.activeTab = tabId;
            }
        },
        confirmTabChange(confirmation) {
            const activeTab = confirmation ? `${this.possibleTab}Tab` : `${this.activeTab}Tab`;
            const activePanel = confirmation ? this.possibleTab : this.activeTab;
            const inactiveTab = !confirmation ? `${this.possibleTab}Tab` : `${this.activeTab}Tab`;
            const inactivePanel = !confirmation ? this.possibleTab : this.activeTab;
            const activeTabElement = document.getElementById(activeTab);
            const activePanelElement = document.getElementById(activePanel);
            const inactiveTabElement = document.getElementById(inactiveTab);
            const inactivePanelElement = document.getElementById(inactivePanel);
            if (activeTabElement) {
                activeTabElement.classList.add('active');
                activeTabElement.setAttribute('aria-selected', 'true');
            }
            if (activePanelElement) {
                activePanelElement.classList.add('show', 'active');
            }
            if (inactiveTabElement) {
                inactiveTabElement.classList.remove('active');
                inactiveTabElement.setAttribute('aria-selected', 'false');
            }
            if (inactivePanelElement) {
                inactivePanelElement.classList.remove('show', 'active');
            }
            if (confirmation) {
                this.activeTab = this.possibleTab;
            }
            this.possibleTab = '';
        }
    }
});
